import {
  mapRenderSizeFromPreset,
  mapThumbnailSizeFromPreset,
} from "PosterEditor/model/poster-project";
import { MapStaticImageOptions } from "PosterEditor/model/poster-project";
import { LngLat } from "mapbox-gl";

export const useMapBoxUtils = (accessToken: string) => {
  const getStaticMapURL = (options: MapStaticImageOptions) => {
    const fullRender = process.env.REACT_APP_FULL_RENDER === "true";
    const renderSize = options.isThumbnail
      ? mapThumbnailSizeFromPreset(
          options.renderSizePreset,
          options.borderWidthMM
        )
      : mapRenderSizeFromPreset(
          options.renderSizePreset,
          options.borderWidthMM
        );

    let largerSize = `${renderSize.width}x${renderSize.height}`;
    if (fullRender && options.isThumbnail === false) {
      largerSize = `${renderSize.width}x${renderSize.height}@2x`;
    }
    const style = options.mapStyle.replace("mapbox://styles/", "").trim();

    const staticMapUrl = `https://api.mapbox.com/styles/v1/${style}/static/[${options.southwest.lng},${options.southwest.lat},${options.northeast.lng},${options.northeast.lat}]/${largerSize}?access_token=${accessToken}`;

    return staticMapUrl;
  };

  const getQuadrantURLs = (options: MapStaticImageOptions) => {
    const midLat = (options.northeast.lat + options.southwest.lat) / 2;
    const midLng = (options.northeast.lng + options.southwest.lng) / 2;

    const quadrants: { name: string; northeast: LngLat; southwest: LngLat }[] =
      [
        {
          name: "topLeft",
          northeast: new LngLat(midLng, options.northeast.lat),
          southwest: new LngLat(options.southwest.lng, midLat),
        },
        {
          name: "topRight",
          northeast: new LngLat(options.northeast.lng, options.northeast.lat),
          southwest: new LngLat(midLng, midLat),
        },
        {
          name: "bottomLeft",
          northeast: new LngLat(midLng, midLat),
          southwest: new LngLat(options.southwest.lng, options.southwest.lat),
        },
        {
          name: "bottomRight",
          northeast: new LngLat(options.northeast.lng, midLat),
          southwest: new LngLat(midLng, options.southwest.lat),
        },
      ];

    const result = quadrants.map((quadrant) => ({
      name: quadrant.name,
      url: getStaticMapURL({
        ...options,
        northeast: quadrant.northeast,
        southwest: quadrant.southwest,
      }),
    }));
    return result;
  };

  return { getStaticMapURL, getQuadrantURLs };
};
